export default "__VITE_ASSET__3a836829__"